<script setup>
import { __, getFormValuesFromLocalStorage, SelfcareAccountSubscriberAddService, sendAbroadData } from '@/utils'
import { ref, inject, computed } from 'vue';
import Plan from "./parts/plan.vue";
 
const savedFields = getFormValuesFromLocalStorage();
const plan = JSON.parse(localStorage.getItem('formRoaming')); 
const showError = ref(false);
const loading = ref(false);

const { 
    hideForm,
    showSuccessPage
} = inject('step');


const goToSuccessPage = async () => {
    let responseObj = '';
    loading.value = true;
    try {
    const response = await SelfcareAccountSubscriberAddService(
        savedFields?.accountToken ? savedFields?.accountToken : '',
        {
            'subscriber_id' : savedFields?.SubscriberID ? savedFields?.SubscriberID : '',
            'product_id' : plan?.product_id ? plan?.product_id : '',
            'days_amount' : plan?.duration ? plan.duration : '',
            'start_date' : savedFields?.departureDate ? savedFields?.departureDate : '',
        }
    );
    responseObj = JSON.parse(response.data);
  } catch (error) {
    console.error('Error fetching roaming plan:', error);
  }
  loading.value = false;

  if(responseObj?.response?.status){

    localStorage.setItem('formRoaming', JSON.stringify({
        ...plan,
        account_first_name: responseObj?.response?.account_first_name
    }));

    sendAbroadData();

    hideForm.value = true;
    showSuccessPage.value = true;
  }else{
    showError.value = true;
  }
}
</script>
<template>
    <div class="form__group form__group--last-step">
        <header class="form__head">
            <h2>
                {{ __('How fun!') }}
            </h2>
        </header><!-- /.form__head-->    
        <p>
            {{ __("Your package details have been successfully received. We’re almost done!") }}
        </p>
        <strong>
            {{ __('You have chosen to purchase the following package:') }}
        </strong>

        <Plan
            v-if="plan"
            :plan="plan"
        />

        <div v-if="showError" style="color:red">
            ישנה טעות בהזמנה.
        </div>

        <button
            class="btn btn--black btn--arrows"
            type="button"
            @click.prevent="goToSuccessPage"
            :disabled="loading"
        >
            <img :src="`${theme_path.url}/resources/images/spinner.svg`" alt="" v-if="loading">
            {{ __('To complete the order') }}
        </button><!-- /.form__btn -->
    </div><!-- /.form__group -->
</template>
